/*
 * Редактирование кейсета - https://tanker.yandex-team.ru/project/direct-components/keyset/components%2FTooltip%2FTooltip.i18n.ts
 * Документация локализации - https://a.yandex-team.ru/arcadia/adv/frontend/docs/monorepo/i18n.md
 */
import { createI18n, createI18nRaw, createKeyset } from '@adv-frontend/l10n/src/i18n';
const keyset = createKeyset({
    Закрыть: {
        ru: 'Закрыть',
        en: 'Close',
        tr: 'Kapat',
        'zh-Hans': '关闭',
    },
    Понятно: {
        ru: 'Понятно',
        en: 'OK',
        tr: 'Anladım',
        'zh-Hans': 'OK',
    },
});
export const i18n = createI18n(keyset);
export const i18nRaw = createI18nRaw(keyset);
